import { useDispatch, useSelector } from "react-redux";
import { useEffect, useCallback, useRef } from "react";
import { APICONSTANT } from "../../utils/api/Config";
import { store } from "../../utils/store/index";
import { getFetchData, postFetchData } from "../../utils/api/FetchData";
import {
  clearDynamicData,
  setAiInsightsRemarks,
  setDynamicAnalysisData,
  setDynamicData,
  setChartFilterData,
} from "./store";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

interface RootState {
  time?: {
    time_data?: {
      from_date?: string;
      to_date?: string;
    };
  };
  district?: {
    region_code?: string;
    district_code?: string;
    division_code?: string;
    taluk_code?: string;
    village_code?: string;
  };
  stateDetails?: {
    isd_code?: string;
    nisd_code?: string;
    fline_code?: string;
    medium_code?: string;
  };
  applicationStatus?: {
    drillDownDistrictCode?: string;
    drillDownTalukCode?: string;
    drillDownVillageCode?: string;
  };
}
const CustomHookForRuralDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectorData = useSelector((state: RootState) => state);
  const districtDetails = useSelector((state: RootState) => state.district);

  // Store latest selector data in useRef to avoid stale state issues
  const latestSelectorData = useRef(selectorData);
  useEffect(() => {
    latestSelectorData.current = selectorData; // Update latest state when Redux changes
  }, [selectorData]); // Re-run when selectorData changes

  // Tracks the most recently fired request per chart id, so a slower,
  // superseded request (e.g. an earlier unfiltered fetch for the same
  // chart) can't overwrite a newer one's result when it finally resolves.
  const latestRequestSeq = useRef<{ [chartId: string]: number }>({});

  const location = useParams();

  const ruralDetailsCount = useCallback(
    async (id: number | string, props) => {
      var parentID = props?.chartListData?.id;

      const has_popup_chart =
        store.getState()?.chartListDetails?.componentData?.ALL?.[
          props
        ]?.has_popup;

      const has_popup =
        store.getState()?.chartListDetails?.componentData?.ALL?.[
          parentID
        ]?.has_popup ||
        store.getState()?.time?.tabs?.[props]?.has_popup;

      const has_popup_table =
        store.getState()?.chartListDetails?.componentData?.ALL;
      const data: any = {
        from_date: store.getState()?.time?.time_data?.from_date,
        to_date: store.getState()?.time?.time_data?.to_date,
        // from_date: "2025-01-01",
        // to_date: "2025-02-01",
        region: store.getState()?.district?.region_code,
        district: location?.districtCode
          ? [location.districtCode]
          : store.getState()?.district?.district_code,
        // division: store.getState()?.district?.division_code,
        taluk: store.getState()?.district?.taluk_code,
        village: store.getState()?.district?.village_code,
        service: store.getState()?.stateDetails?.isd_code,
        mode: store.getState()?.stateDetails?.nisd_code,
        land_type: store.getState()?.stateDetails?.fline_code,
        source: store.getState()?.stateDetails?.medium_code,
        drilldownChartRowDistrictCode:
          store.getState()?.applicationStatus?.drillDownDistrictCode,
        drilldownChartRowTalukCode:
          store.getState()?.applicationStatus?.drillDownTalukCode,
        drilldownChartRowVillageCode:
          store.getState()?.applicationStatus?.drillDownVillageCode,

        tabId: store.getState().chartListDetails?.componentData
          ?.ALL?.[id]?.has_tab
          ? store.getState()?.time?.tabs?.[id]?.id
          : "",

        popupChartRtrStrCitizenType: has_popup_chart
          ? store.getState()?.applicationStatus?.pieChartId
          : "",

        popupDistrictCode: has_popup_table
          ? store.getState()?.applicationStatus?.tableChartId
          : "",

        popupTableColumn:
          store.getState()?.applicationStatus?.[parentID]
            ?.accessorKey,

        popupTalukCode:
          store.getState()?.applicationStatus?.talukCode,
        // hasPopup: has_popup,

        hasPopup: has_popup,
        popupTypeForTabBasedChart:
          store.getState()?.time?.selectedAppStatus,
      };

      const requestSeq = (latestRequestSeq.current[id] || 0) + 1;
      latestRequestSeq.current[id] = requestSeq;

      await dispatch(setChartFilterData(data));
      const response = await postFetchData(
        1,
        dispatch,
        APICONSTANT.chart_details + id,
        data,
        id
      );

      // A newer request for this same chart id was fired while this one
      // was in flight (e.g. expanding a different row before this one
      // finished) - ignore this now-stale response instead of letting it
      // overwrite the newer, correct data.
      if (latestRequestSeq.current[id] !== requestSeq) {
        return;
      }

      if (response?.status === 1) {
        dispatch(setDynamicData({ id, data: response?.data }));
        // dispatch(setDynamicAnalysisData({ id, data: analysisDAta }));

        // if (response?.ai_analysis?.success) {
        //   dispatch(setDynamicAnalysisData({ id, data: response?.ai_analysis }));
        // }

        return response?.data;
      } else {
        dispatch(clearDynamicData(id));
      }
    },
    [latestSelectorData, dispatch] // Include relevant dependencies here
  );

  const DistrictDetailsHandleChange = async (
    name,
    values,
    url,
    fun,
    loginRes
    // selectedCodeFun
  ) => {
    //  dispatch(fun(values));
    const requestData = {
      region_code: districtDetails?.region_code || values,
      district_code: districtDetails?.district_code,
      division_code: districtDetails?.division_code,
      taluk_code: districtDetails?.taluk_code,
      village_code: districtDetails?.village_code,
    };
    details(url, requestData, fun, loginRes);
  };

  const details = async (url, requestData, fun, selectedCodeFun, loginRes) => {
    const response = await postFetchData(1, dispatch, url, requestData ?? []); // Use dynamic API URL
    if (response?.status === 1) {
      if (response?.data?.length !== 0) {
        await dispatch(fun([{ id: "0", name: "All" }, ...response?.data]));

        if (requestData.length == 0) {
          await dispatch(
            selectedCodeFun(response?.data?.map((item: any) => item.id))
          );
        }

        // if (loginRes?.first_login == "first_login") {
        //   navigate("/change-password");
        // } else {
        //   navigate("/chart/1");
        // }
      }
    }
  };

  //write a post api
  const getAnalysisData = useCallback(
    async (id: number | string, props: any) => {
      // var parentID = props?.chartListData?.id;

      const payload = { chartData: props };

      const response = await postFetchData(
        1,
        dispatch,
        APICONSTANT.analysis + id + "/analysis",
        payload,
        id
      );
      //  dispatch(setDynamicAnalysisData({ id, data: analysisDAta?.data }));

      if (response?.status === 1) {
        await dispatch(setDynamicAnalysisData({ id, data: response?.data }));
        return response?.data;
      }
    },
    [latestSelectorData, dispatch] // Include relevant dependencies here
  );
  const aiInsightsRemarksSubmit = useCallback(
    async (id: number | string, props: any) => {
      // var parentID = props?.chartListData?.id;

      const payload = props;

      const response: any = await postFetchData(
        1,
        dispatch,
        APICONSTANT.aiRemarkSubmit + id,
        payload,
        id
      );
      if (response?.status === 1) {
        toast.success(response.message);
        await dispatch(setAiInsightsRemarks({ id, data: response?.data }));
        return response?.data;
      }
    },
    [latestSelectorData, dispatch] // Include relevant dependencies here
  );
  const getRemarksList = useCallback(
    async (id: any) => {
      // var parentID = props?.chartListData?.id;

      const response = await getFetchData(
        1,
        dispatch,
        APICONSTANT.chartReviewList
      );
      if (response?.status === 1) {
        await dispatch(setAiInsightsRemarks({ id, data: response?.data }));
        return response?.data;
      }
    },
    [latestSelectorData, dispatch] // Include relevant dependencies here
  );

  return {
    ruralDetailsCount,
    getAnalysisData,
    DistrictDetailsHandleChange,
    details,
    getRemarksList,
    aiInsightsRemarksSubmit,
  };
};

export default CustomHookForRuralDetails;
